import { Box } from '@factorialco/deprecated-design-system'
import { DataTableFilter, FilterType } from 'generated/resources/datatable.graphql'
import {
  FinanceFinancialDocumentFilter,
  FinancialProjectForSelectFragment,
} from 'generated/resources/graphql'

import { Filter } from 'modules/core/components/DataTable/types'
import useFilter from 'modules/core/components/Filter/base/useFilter'
import i18n from 'modules/core/lib/i18n'

import { FinancialProjectSelector } from 'modules/project_management/components/selectors/FinancialProjectSelector'

import { InvoiceFilters } from '../DataTableWrapper/types'

const ProjectsFilterComponent = () => {
  const { value, onValueChange } = useFilter<FinancialProjectForSelectFragment[]>()

  return (
    <Box width="s400" flexDirection="column" overflowY="hidden" overflowX="hidden" hideScrollBar>
      <FinancialProjectSelector multiple alwaysOpen value={value ?? []} onChange={onValueChange} />
    </Box>
  )
}

const createProjectFilterConfig = (
  onUpdateProjectFilter: (filter?: Filter<number[]>) => void,
  currentProjectIds?: number[]
): DataTableFilter<FinanceFinancialDocumentFilter> => {
  return {
    identifier: 'project_id',
    title: i18n.t('finance.invoices.list.fields.project'),
    path: 'projectId',
    type: FilterType.Entity,
    default: Boolean(currentProjectIds?.length),
    onUpdateValue: onUpdateProjectFilter,
    categories: [
      {
        kind: 'Entity',
        operation: 'in',
        nameAttribute: 'name',
        value: currentProjectIds || [],
        component: () => <ProjectsFilterComponent />,
      },
    ],
  }
}

export const projectFilter = (
  onFilterChange: (filters: InvoiceFilters) => void = () => {},
  currentProjectIds?: number[]
): DataTableFilter<FinanceFinancialDocumentFilter> => {
  const onUpdateProjectFilter = (filter?: Filter<number[]>) => {
    const filterValue = Array.isArray(filter?.value) ? filter.value : []
    onFilterChange({ projectIds: filterValue })
  }

  return createProjectFilterConfig(onUpdateProjectFilter, currentProjectIds)
}
